import { MATRIX_BACKEND } from '@/remotes';
import { defineStore } from 'pinia';

export const useCitiesRestrictions = defineStore({
  id: 'citiesRestrictions',
  state: () => ({
    cityFrom: null,
    cityTo: null,
  }),
  getters: {
    getCityFromRestrictions: (state) => state.cityFrom,
    getCityToRestrictions: (state) => state.cityTo,
  },
  actions: {
    async handleCityRestrictions(cityType, city) {
      try {
        const cityRestrictions = (await MATRIX_BACKEND.get(`/api/public/storage/${city.id}`)).data;
        this[cityType] = { ...cityRestrictions, title: city.title };
      } catch {
        this[cityType] = null;
      }
    },
  },
});
